module.exports = __webpack_public_path__ + "images/videoCaseStudy-urbanPartnershipBank-logo.png?h=2978702d67d2c260fd47323f4b0a796c";


//////////////////
// WEBPACK FOOTER
// ./src/theme/images/videoCaseStudies/urbanPartnershipBank/videoCaseStudy-urbanPartnershipBank-logo.png
// module id = 2125
// module chunks = 12 15